import { Component } from '@angular/core';

@Component({
  selector: 'app-academic-overview',
  imports: [
  ],
  templateUrl: './academic-overview.html',
  styleUrl: './academic-overview.css',
})
export class AcademicOverview {

}
